<template>
    <div class="exam-list">
        <manage-title>机构教师</manage-title>
        <div class="form">
            <div class="xy-between">
                <el-button
                    v-if="isOrgManager&&$store.state.isCheckEnd"
                    icon="el-icon-circle-plus"
                    type="success"
                    plain
                    size="medium"
                    @click="Add"
                    style="margin-right: 20px"
                >新增</el-button
                >
                <div class="xy-center">
                    <el-input
                        placeholder="请输入关键字检索..."
                        v-model="keyWord"
                        style="margin-right: -5px"
                        @keyup.enter.native="GetOrganManage(true)"
                    ></el-input>
                    <el-button
                        type="primary"
                        size="medium"
                        icon="el-icon-search"
                        style="z-index: 10"
                        @click="GetOrganManage(true)"
                    >检索</el-button
                    >
                </div>
            </div>
        </div>
        <div class="table">
            <el-table
                :data="data"
                row-key="id"
                v-loading="loading"
                style="width: 100%;"
            >
                <el-table-column label="用户名" prop="UserName" width="160" />
                <el-table-column label="真实姓名" prop="RealName" width="160" />
                <el-table-column label="角色" prop="RoleName" width="160" />
                <el-table-column
                    label="联系电话"
                    prop="Telephone"
                    align="center"
                    width="140"
                />
                <el-table-column
                    label="邮箱"
                    prop="Email"
                    align="center"
                    width="200"
                />
                <el-table-column
                    label="创建时间"
                    prop="CreateTime"
                    align="center"
                    width="160"
                />
                <el-table-column
                    label="创建者"
                    prop="CeateName"
                    align="center"
                    width="160"
                >
                </el-table-column>

                <el-table-column
                    label="最近更新时间"
                    prop="ModifyTime"
                    align="center"
                    width="160"
                >
                </el-table-column>

                <el-table-column
                    label="备注"
                    prop="DescInfo"
                    align="left"
                    width="200"
                >
                </el-table-column>

                <el-table-column
                    label="操作"
                    v-if="isOrgManager"
                    fixed="right"
                    align="center"
                    width="140">
                    <template #default="{row}">
                        <el-button v-if="$store.state.isCheckEnd" size="mini" @click="Edit(row)"

                        >编辑</el-button
                        >
                        <el-button
                            size="mini"
                            type="danger"
                            class="table-btn"
                            @click="Delete(row)"
                        >删除</el-button
                        >
                        <el-button
                            type="info"
                            size="mini"
                            class="table-btn2"
                            @click="Reset(row)"
                        >重置密码</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="xy-center mt-17 mb-10">
            <el-pagination
                hide-on-single-page
                @current-change="GetOrganManage()"
                @size-change="GetOrganManage(true)"
                :current-page.sync="pageIndex"
                :page-size.sync="pageSize"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
        </div>

        <!-- 弹窗 -->
        <el-dialog
            :destroy-on-close="true"
            :close-on-click-modal="false"
            width="600px"
            :title="dialogTitle"
            :visible.sync="organVisible"
            @close="closeDialog"
            custom-class="m-dialog"
        >
            <el-form
                ref="manageForm"
                :rules="rules"
                size="medium"
                :model="manageForm"
                label-width="130px"
            >
                <el-form-item label="用户名" prop="UserName">
                    <el-input
                        v-model="manageForm.UserName"
                        class="dialog-text"
                        :disabled="accountDisabled"
                    ></el-input>
                </el-form-item>

                <el-form-item v-if="pwdShow" label="密码" prop="pwd">
                    <el-input
                        v-model="manageForm.pwd"
                        class="dialog-text"
                    ></el-input>
                </el-form-item>

                <el-form-item label="真实姓名" prop="RealName">
                    <el-input
                        v-model="manageForm.RealName"
                        class="dialog-text"
                    ></el-input>
                </el-form-item>

                <el-form-item label="联系电话">
                    <el-input
                        v-model="manageForm.Telephone"
                        class="dialog-text"
                    ></el-input>
                </el-form-item>

                <el-form-item label="Email">
                    <el-input
                        v-model="manageForm.Email"
                        class="dialog-text"
                    ></el-input>
                </el-form-item>

                <el-form-item label="QQ">
                    <el-input
                        v-model="manageForm.QQ"
                        class="dialog-text"
                    ></el-input>
                </el-form-item>

                <el-form-item label="备注">
                    <el-input
                        v-model="manageForm.DescInfo"
                        type="textarea"
                        class="dialog-text"
                    ></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="closeDialog">取 消</el-button>
                <el-button
                    size="medium"
                    type="primary"
                    @click="Save('manageForm')"
                >确 定</el-button
                >
            </div>
        </el-dialog>

        <!-- 密码弹窗 -->
        <el-dialog
            :destroy-on-close="true"
            :close-on-click-modal="false"
            width="600px"
            title="重置密码"
            :visible.sync="pwdVisible"
            custom-class="m-dialog"
            :lock-scroll="false"
            @close="closeDialog"
        >
            <el-form ref="" size="medium" label-width="130px">
                <el-form-item label="密码" style="margin-top:20px">
                    <el-input
                        type="text"
                        v-model="resetPwd"
                        show-word-limit
                        maxlength="20"
                        clearable
                        class="dialog-text"
                        placeholder="请输入重置后密码..."
                    ></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="closePwdDialog"
                >取 消</el-button
                >
                <el-button size="medium" type="primary" @click="ResetPassword"
                >确 定</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import ManageTitle from "@/components/manager/ManageTitle";
import {
    GetOrganManage,
    addOrgTeacher,
    DeleteManager,
    ResetManagePassword
} from "@/api/organ";
import { sm2Encrypt } from "@/utils/sm2"
import {isObject} from "lodash";

export default {
    name: "teacher",
    components: { ManageTitle },
    data() {
        return {
            data: [],
            total: 0,
            pageIndex: 1,
            pageSize: 10,
            keyWord: "",
            loading: false,
            // 弹框（默认隐藏）
            organVisible: false,
            // 密码弹框（默认隐藏）
            pwdVisible: false,
            // 弹框标题
            dialogTitle: "",
            // 是否禁用用户名
            accountDisabled: false,
            // 密码文本框
            pwdShow: true,
            // 重置后密码
            resetPwd: "",
            // 表单
            manageForm: {
                ID: "",
                UserGroupId: "2",
                UserName: "",
                UserPass: "",
                pwd: "",
                RealName: "",
                Telephone: "",
                Email: "",
                QQ: "",
                Address: "",
                DescInfo: "",
                GroupUserId: "",
                RoleType: null
            },
            manageId: "",
            rules: {
                UserName: [
                    {
                        required: true,
                        message: "请输入用户名",
                        trigger: "blur"
                    },
                ],
                pwd: [
                    {
                        required: true,
                        message: "请填写密码",
                        trigger: "blur"
                    },
                    {
                        min: 6,
                        max: 20,
                        message: "长度在 6 到 20 个字符",
                        trigger: "blur"
                    }
                ],
                RealName: [
                    {
                        required: true,
                        message: "请填写真实姓名",
                        trigger: "blur"
                    },
                    {
                        min: 2,
                        max: 20,
                        message: "长度在 2 到 20 个字符",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    created() {
        this.GetOrganManage();
    },
    computed: {
        isOrgManager () {
            const userInfo = this.$store.state.userInfo
            if (isObject(userInfo)) {
                return userInfo.isOrgManager
            }
            return false
        }
    },
    methods: {
        // 获取机构管理员信息
        async GetOrganManage(isRefresh) {
            if (isRefresh === true) {
                this.pageIndex = 1;
            }
            try {
                this.loading = true;
                const { data } = await GetOrganManage({
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize,
                    keyWord: this.keyWord,
                    sortBy: "ModifyTime",
                    sortOrder: "desc",
                    ManageType: 5
                });
                this.data = data.data;
                this.total = data.count;
            } catch (err) {
                this.$toast("获取失败");
            }
            this.loading = false;
        },
        // 打开新增窗口
        Add() {
            this.dialogTitle = "新增机构教师";
            this.organVisible = true;
            this.accountDisabled = false;
            this.pwdShow = true;
        },
        // 打开编辑窗口
        Edit(row) {
            this.dialogTitle = "编辑机构教师";
            this.accountDisabled = true;
            this.pwdShow = false;

            this.manageForm.ID = row.ID;
            this.manageForm.UserName = row.UserName;
            this.manageForm.RealName = row.RealName;
            this.manageForm.Telephone = row.Telephone;
            this.manageForm.Email = row.Email;
            this.manageForm.QQ = row.QQ;
            this.manageForm.DescInfo = row.DescInfo;
            this.manageForm.GroupUserId = row.GroupUserId;

            this.organVisible = true;
        },
        // 保存
        async Save(formName) {
            var result = false;
            this.$refs[formName].validate((valid) => {
                result = valid;
            });
            if (result) {
                try {
                    if (!this.manageForm.ID) {
                        this.manageForm.UserPass = sm2Encrypt(this.manageForm.pwd);
                    }

                    const { data } = await addOrgTeacher(this.manageForm);
                    if (data.code === 100) {
                        this.$message({ message: data.msg, type: "success" });
                        this.GetOrganManage();
                        this.organVisible = false;
                    } else {
                        this.$message({ message: data.msg, type: "error" });
                    }
                } catch (err) {
                    this.$message({
                        message: "服务器开小差了！",
                        type: "error"
                    });
                }
            }
        },
        // 删除
        Delete(row) {
            try {
                this.$confirm("确认删除机构教师：" + row.UserName + "?", "提示", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                    lockScroll: false
                })
                    .then(() => {
                        this.DeleteManage(row.ID);
                    })
                    .catch(() => {});
            } catch (err) {
                this.$message({ message: "服务器开小差了！", type: "error" });
            }
        },
        // 删除管理员信息
        async DeleteManage(Id) {
            const { data } = await DeleteManager({ Id: Id });
            if (data.code === 100) {
                this.$message({ message: data.msg, type: "success" });
                this.GetOrganManage();
            } else {
                this.$message({ message: data.msg, type: "error" });
            }
        },
        // 重置
        Reset(row) {
            this.pwdVisible = true;
            this.manageId = row.ID;
        },
        // 重置密码
        async ResetPassword() {
            if (!this.resetPwd) {
                this.$message({ message: "重置密码不能为空！", type: "error" });
                return;
            }

            const { data } = await ResetManagePassword({
                Id: this.manageId,
                pwd: sm2Encrypt(this.resetPwd)
            });
            if (data.code === 100) {
                this.$message({ message: data.msg, type: "success" });
                this.GetOrganManage();
                this.closePwdDialog();
            } else {
                this.$message({ message: data.msg, type: "error" });
            }
        },
        // 关闭弹框
        closeDialog() {
            this.organVisible = false;

            this.manageForm = {
                ID: "",
                UserGroupId: "2",
                UserName: "",
                UserPass: "",
                pwd: "",
                RealName: "",
                Telephone: "",
                Email: "",
                QQ: "",
                Address: "",
                DescInfo: "",
                GroupUserId: "",
                RoleType: null
            };
        },
        // 关闭重置密码弹框
        closePwdDialog() {
            this.pwdVisible = false;
            this.resetPwd = "";
            this.manageId = "";
        }
    }
};
</script>

<style scoped lang="less">
.form {
    padding: 20px;

    ::v-deep .el-input__inner {
        height: 35px;
    }
}

.table {
    padding: 0 20px 20px 20px;

    .table-btn {
        margin-left: 5px;
    }
    .table-btn2 {
        margin-top: 5px;
    }
}

.exam-list {
    width: 100%;

    ::v-deep.operation {
        button {
            margin-top: 10px;
        }
    }

    .info {
        margin-left: 30px;
    }
}

::v-deep .el-dialog__body {
    .dialog-text {
        width: 350px;
    }
}

//::v-deep .el-button--primary {
//    color: #fff;
//    background-color: #41b584 !important;
//    border-color: #41b584 !important;
//}
</style>
